export { default } from './Accordion';
export { default as accordionClasses } from './accordionClasses';
export * from './accordionClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Accordion/index.js
// module id = 784
// module chunks = 22